import styled from "styled-components";
import { Column } from "../../../components/ui/grid/column.component";
import { SectionTitle } from "../../../components/ui/section-title/section-title.component";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { Row } from "../../../components/ui/grid/row.component";
import { TextButton } from "../../../components/ui/text-button/text-button.component";
import { Pill } from "../../../components/ui/pill/pill.component";
import { useState } from "react";
import { colors } from "../../../theme/colors";
import { Tabs } from "../../../components/ui/tabs/tabs.component";
import { Project } from "../components/project.component";
import { FilmProfile } from "../../../models/film-profile.model";
import { useNavigate } from "react-router-dom";

const filters = [
  {
    label: "draft",
    filterFn: (project: FilmProfile) => project.status === "draft",
  },
  {
    label: "published",
    filterFn: (project: FilmProfile) =>
      project.status === "published" && !project.is_distributed,
  },
  {
    label: "distributing",
    filterFn: (project: FilmProfile) =>
      project.status === "published" && project.is_distributed,
  },
];

enum ProjectType {
  Film = 0,
  Series = 1,
}

export const ProjectSection = ({ films }: { films: FilmProfile[] }) => {
  const navigate = useNavigate();

  const [activeFilterIndex, setActiveFilterIndex] = useState<number | null>(
    null
  );
  const [activeProjectType, setActiveProjectType] = useState<ProjectType>(
    ProjectType.Film
  );

  return (
    <Main>
      <Spacer direction="bottom" size={70} />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <SectionTitle>My Projects</SectionTitle>
        <div style={{ position: "absolute", right: "2rem" }}>
          <TextButton onClick={() => navigate("/f")} color="complement">
            View All &rarr;
          </TextButton>
        </div>
      </Row>
      <Spacer direction="bottom" size={10} />
      <FilterByLabel>Filter By</FilterByLabel>
      <Spacer direction="bottom" size={5} />
      <OptionsRow>
        <Row style={{ gap: "0.5rem", zIndex: 2 }}>
          {filters.map((filter, index) => (
            <Pill
              style={{
                backgroundColor:
                  activeFilterIndex === index
                    ? colors.primary.hex
                    : colors.white.hex,
                color:
                  activeFilterIndex === index
                    ? colors.white.hex
                    : colors.black.hex,
              }}
              onClick={() => {
                setActiveFilterIndex(
                  activeFilterIndex === index ? null : index
                );
              }}
            >
              {filter.label}
            </Pill>
          ))}
        </Row>
        <TypeContainer>
          {/* <Tabs
            tabs={[{ label: "Films" }]}
            activeTab={activeProjectType}
            onTabSelected={(activeTab: ProjectType) =>
              setActiveProjectType(activeTab)
            }
          /> */}
        </TypeContainer>
      </OptionsRow>
      <Spacer direction="bottom" size={15} />
      <Row
        style={{
          gap: "1.5rem",
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          overflowY: "visible",
          padding: "6rem 0",
          margin: "-6rem 0",
        }}
      >
        {films.length === 0 ? <NoResultsText>No films!</NoResultsText> : null}
        {films
          .filter((film) =>
            activeFilterIndex === null
              ? true
              : filters[activeFilterIndex].filterFn(film)
          )
          .map((film) => (
            <Project kind="film" project={film} key={film.id} />
          ))}
        {/* <Project />
        <Project />
        <Project />
        <Project />
        <Project /> */}
      </Row>
    </Main>
  );
};

const NoResultsText = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${colors.text.hex};
`;

const Main = styled(Column)`
  max-width: 100%;
  flex: 1;
  align-items: start;
`;

const FilterByLabel = styled.label`
  font-size: 1.4rem;
  font-weight: 500;
`;

const OptionsRow = styled(Row)`
  width: 100%;
  justify-content: space-between;
  padding-right: 2rem;

  @media only screen and (max-width: 23.4375em) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
  }
`;

const TypeContainer = styled.div`
  position: absolute;
  right: 2rem;

  @media only screen and (max-width: 23.4375em) {
    position: relative;
    right: auto;
  }
`;
